import { render } from "./ResetPasswordForm.vue?vue&type=template&id=1578b9da&scoped=true"
import script from "./ResetPasswordForm.vue?vue&type=script&lang=js"
export * from "./ResetPasswordForm.vue?vue&type=script&lang=js"

import "./ResetPasswordForm.vue?vue&type=style&index=0&id=1578b9da&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-1578b9da"

export default script